<template>
  <div class="page-dealers-resource">
		<action-sidebar
			title="Recursos"
			:value="true"
			:width="644"
			@close-modal="closeModal"
			>
		<v-tabs
			v-model="tabsResource"
			right
			slider-color="cyan"
		>
			<v-tab v-for="(item, index) in tabs" :key="index">
				{{ item.name }}
			</v-tab>
				<v-tabs-items>
					<v-tab-item>
						<v-flex xs9 text-xs-left>
							<v-select
							:items="listApplications"
							background-color="white"
							box
							class="body-1 mt-4 px-3"
							hide-details
							item-text="name"
							item-value="id"
							label="Aplicaciones"
							v-model="appId"
							@change="loadResource(1)"
							></v-select>
						</v-flex>
						<app-table
						selectable
						class="mt-5 is-not-selectable px-3"
						name="resource"
						:selected-value="selectedValue"
						:check-all="checkAll"
						:columns="columns"
						:rows="listResource"
						:current-page="currentPage"
						:last-page="lastPage"
						:inputSearch="false"
						:filterColumns="false"
						@on-page="loadResource"
						@row-is-selected="rowIsSelected"
						@on-selected-all="allSelected"
						>
							<template slot="rows" slot-scope="props">
								<td class="is-not-selectable"
								v-show="showRow(columns, 1)">
									{{ props.row.uri }}
								</td>
								<td v-show="showRow(columns, 2)">
									{{ props.row.description }}
								</td>
								<td v-show="showRow(columns, 3)">
									{{ props.row.module ? props.row.module.data && props.row.module.data.name : '' }}
								</td>
							</template>
						</app-table>
					</v-tab-item>
					<v-tab-item>
						<v-flex xs9 ml-3>
							<v-select
							background-color="white"
							box
							class="body-1 mt-4 px-2"
							hide-details
							:items="listApplications"
							item-text="name"
							item-value="id"
							label="Aplicaciones"
							v-model="appIdAssigned"
							></v-select>
						</v-flex>
					<app-table
						name="resource"
						class="mt-5 is-not-selectable px-3"
						:selected-value="selectedValueAssigned"
						:columns="columns"
						:check-all="checkAllAssigned"
						:rows="listResourceAssigned"
						:current-page="currentPageAssigned"
						:last-page="lastPageAssigned"
						:inputSearch="false"
						:filterColumns="false"
						selectable
						@on-page="loadResourceAssigned"
						@row-is-selected="rowIsSelectedDeallocated"
						@on-selected-all="allSelectedAssigned"
						>
							<template slot="rows" slot-scope="props">
								<td class="is-not-selectable" 
								v-show="(columns, 1)">
									{{ props.row.uri }}
								</td>
								<td v-show="(columns, 2)">
									{{ props.row.description }}
								</td>
								<td v-show="(columns, 3)">
									{{ props.row.module ? props.row.module.data && props.row.module.data.name : '' }}
								</td>
							</template>
						</app-table>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
			<section class="modal-filter-footer pt-4 pb-4 center-buttons">
				<v-btn
				class="btn-action caption ml-2"
				color="pink"
				@click="closeModal">
					Cancelar
				</v-btn>
				<v-btn
				class="btn-action caption ml-2"
				color="success"
				:disabled="disabledAssigned(1)"
				@click="assignedResource"
				>
				Asignar
				</v-btn>
				<v-btn
				class="btn-action caption ml-2"
				color="success"
				:disabled="disabledDeallocate(0)"
				@click="deallocateResource"
				>
				Desasignar
				</v-btn>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.loadApplications();
	this.loadResource();
	this.loadResourceAssigned();
}

async function loadApplications() {
	const params = {
		page: 1,
		perPage: 20,
		isSelected: 1,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/apps`, { params });
		this.listApplications = response.data.data;
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

async function loadResource(page = 1) {
	this.currentPage = page;
	this.params.page = this.currentPage;
	const params = {
		isSelected: 0,
		page: this.params.page,
		perPage: 20,
		appId: this.appId,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/resources`, { params });
		this.listResource = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

async function loadResourceAssigned(page = 1) {
	this.currentPageAssigned = page;
	this.params.page = this.currentPageAssigned;
	const params = {
		isSelected: 1,
		page: this.params.page,
		perPage: 20,
		appId: this.appIdAssigned,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/resources`, { params });
		this.listResourceAssigned = response.data.data;
		this.lastPageAssigned = Number(response.headers['x-last-page']);
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

function rowIsSelected(row) {
	this.listResource = this.selectIsRow(this.listResource, this.selectedValue, row);
	this.dataSelected = this.listResource.filter(r => r.flag);
	this.checkAll = this.every(this.listResource, this.selectedValue);
}

function rowIsSelectedDeallocated(row) {
	this.listResourceAssigned =
	this.selectIsRow(this.listResourceAssigned, this.selectedValueAssigned, row);
	this.dataSelectedAssigned = this.listResourceAssigned.filter(r => r.flagAssigned);
	this.checkAllAssigned = this.every(this.listResourceAssigned, this.selectedValueAssigned);
}

async function assignedResource() {
	const resourcesIds = this.dataSelected.map(p => p.id);
	try {
		await this.$http.post(`distributaries/${this.id}/resources`, { resourcesIds });
		this.closeModal();
		this.loadResource();
		this.showNotification('Los recursos fueron asignados correctamente.');
	} catch (error) {
		this.showError();
	}
}

function allSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.listResource = this.listResource.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(element);
		}
		return newRow;
	});
	this.listResource = this.selectIsRow(this.listResource, this.selectedValue, false, checked);
}

function allSelectedAssigned(checked) {
	this.checkAllAssigned = checked;
	this.dataSelectedAssigned = [];
	this.listResourceAssigned = this.listResourceAssigned.map((element) => {
		const newRowAssigned = { ...element };
		newRowAssigned.isSelected = checked;
		if (checked) {
			this.dataSelectedAssigned.push(element);
		}
		return newRowAssigned;
	});
	this.listResourceAssigned =
	this.selectIsRow(this.listResourceAssigned, this.selectedValue, false, checked);
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function disabledAssigned(value) {
	return this.tabsResource === value || this.dataSelected.length < 1;
}

function disabledDeallocate(value) {
	return this.tabsResource === value || this.dataSelectedAssigned.length < 1;
}

async function deallocateResource() {
	const ids = this.dataSelectedAssigned.map(p => p.id);
	const body = {
		page: this.params.page,
		resourcesIds: ids,
	};
	try {
		await this.$http.delete(`distributaries/${this.id}/resources`, { data: body });
		this.closeModal();
		this.loadResourceAssigned();
		this.showNotification('Los recursos fueron desasignados.');
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		appId: '',
		appIdAssigned: '',
		checkAll: false,
		checkAllAssigned: false,
		columns: [
			{ id: 1, name: 'URI', value: 'uri', checked: true, visible: true },
			{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
			{ id: 3, name: 'Módulo', value: 'module', checked: true, visible: true },
		],
		currentPage: 1,
		currentPageAssigned: 1,
		dataSelected: [],
		dataSelectedAssigned: [],
		lastPage: 0,
		lastPageAssigned: 0,
		listApplications: [],
		listApplicationsAssigned: [],
		listResource: [],
		listResourceAssigned: [],
		selectedValue: 'flag',
		selectedValueAssigned: 'flagAssigned',
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
		tabsResource: null,
	};
}

export default {
	name: 'page-dealers-resource',
	created,
	data,
	components: {
		actionSidebar,
	},
	methods: {
		allSelected,
		allSelectedAssigned,
		assignedResource,
		closeModal,
		deallocateResource,
		disabledAssigned,
		disabledDeallocate,
		loadApplications,
		loadResource,
		loadResourceAssigned,
		rowIsSelected,
		rowIsSelectedDeallocated,
	},
	props: {
		id: {
			type: [String, Number],
		},
	},
};
</script>

<style lang="scss">
.center-buttons {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-dealers-resource.vue